(() => {
  const formSelector = '.mio-contact__form';

  const getErrorMessage = (field) => {
    if (field.validity.typeMismatch) return field.dataset.errorInvalid;
    return field.dataset.errorRequired;
  };

  const setFieldError = (field, message) => {
    const error = document.getElementById(`${field.id}-error`);
    if (!error) return;

    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', error.id);
    field.classList.add('mio-contact__input--error');
    error.textContent = message;
    error.hidden = false;
  };

  const clearFieldError = (field) => {
    const error = document.getElementById(`${field.id}-error`);
    if (!error) return;

    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    field.classList.remove('mio-contact__input--error');
    error.textContent = '';
    error.hidden = true;
  };

  const initContactForm = (form) => {
    if (form.dataset.mioValidationReady === 'true') return;
    form.dataset.mioValidationReady = 'true';
    form.noValidate = true;

    const fields = Array.from(form.querySelectorAll('[data-contact-field]'));
    const summary = form.querySelector('[data-contact-error-summary]');
    const summaryList = form.querySelector('[data-contact-error-list]');

    const removeSummaryItem = (field) => {
      const item = Array.from(summaryList.children).find(
        (summaryItem) => summaryItem.dataset.errorFor === field.id,
      );

      item?.remove();
      if (!summaryList.children.length) summary.hidden = true;
    };

    fields.forEach((field) => {
      field.addEventListener('input', () => {
        if (!field.checkValidity() && field.getAttribute('aria-invalid') === 'true') {
          const message = getErrorMessage(field);
          setFieldError(field, message);

          const link = Array.from(summaryList.querySelectorAll('a')).find(
            (summaryLink) => summaryLink.getAttribute('href') === `#${field.id}`,
          );
          if (link) link.textContent = message;
          return;
        }

        clearFieldError(field);
        removeSummaryItem(field);
      });
    });

    form.addEventListener('submit', (event) => {
      const invalidFields = fields.filter((field) => !field.checkValidity());
      if (!invalidFields.length) return;

      event.preventDefault();
      summaryList.replaceChildren();

      invalidFields.forEach((field) => {
        const message = getErrorMessage(field);
        setFieldError(field, message);

        const item = document.createElement('li');
        item.dataset.errorFor = field.id;
        const link = document.createElement('a');
        link.href = `#${field.id}`;
        link.textContent = message;
        item.appendChild(link);
        summaryList.appendChild(item);
      });

      summary.hidden = false;
      summary.focus();
    });

    const status = form.querySelector('[data-contact-status]');
    if (status) {
      requestAnimationFrame(() => status.focus());
    } else if (!summary.hidden && summaryList.children.length) {
      requestAnimationFrame(() => summary.focus());
    }
  };

  const initContactForms = (root = document) => {
    root.querySelectorAll(formSelector).forEach(initContactForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initContactForms());
  } else {
    initContactForms();
  }

  document.addEventListener('shopify:section:load', (event) => initContactForms(event.target));
})();
